import { MemberDashboardLicenseResponse } from './../../../models/ss-api/responses/member.dashboard.license.response';
import { NoteManagerConstructor } from '../../../managers/note.manager';
import { LicenseManager } from '../../../managers/License.manager';
import { MemberEventsService } from '../../../services/member.events.service';
import { Subscription } from 'rxjs';
import { BillingCycleTypes } from '../../../models/domain/invoice';
import { Note, NoteTypes } from '../../../models/domain/note';
import { KeyValuePair } from '../../../models/KeyValuePair';
import { DialogService, DialogOptions } from '../../../services/modal-dialogs/dialog.service';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { NoteManager } from '../../../managers/note.manager';
import { License, LicensePackageTypes, LicenseStatusTypes, LiveHubConnectionStatuses } from '../../../models/domain/license';
import { EntityChangedArgs } from '../../../managers/manager.base';
import { MemberDashboardLicenseResponseArray } from '../../../models/ss-api/responses/member.dashboard.license.response';
import { KeyTransferDialog } from '../../../dialogs/key.transfer/key.transfer.dialog';
import { KeyReassignDialog } from '../../../dialogs/key.reassign/key.reassign.dialog';
import { KeyReactivateDialog } from '../../../dialogs/key.reactivate/key.reactivate.dialog';
import { KeyReactivateDevDialog } from '../../../dialogs/key.reactivate.dev/key.reactivate.dev.dialog';
import { AddLicenseDialog } from '../../../dialogs/add.license/add.license.dialog';
import { MemberDashboard } from '../../../models/ss-api/responses/member.dashboard.response';
import { UserRolesService } from '../../../services/user.roles.service';
import { WindowSettings } from '../../../../app/services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { SortBot } from '../../../../app/helpers/sort';
import { NoteDetailsDialog } from '../../../dialogs/note.details/note.details.dialog';
import { AddGISDialog } from '../../../dialogs/add.gis/add.gis.dialog';
import { SubscribeToLicensesRequest } from '@models/ss-api/requests/subscribe.to.licenses.request';

@Component({
    selector: 'software-licenses',
    templateUrl: './software.licenses.component.html',
    styleUrls: ['./software.licenses.component.css']
})
export class SoftwareLicensesComponent implements OnInit, OnDestroy {
    @Input('OwnLicenses') OwnLicenses: MemberDashboardLicenseResponseArray;
    @Input('DesignersLicenses') DesignersLicenses: MemberDashboardLicenseResponseArray;
    @Input('MemberID') MemberID: number = 0;

    @Input('DashboardData') DashboardData: MemberDashboard;

    @Output() refreshEvent = new EventEmitter();

    OriginalOwnLicenses: MemberDashboardLicenseResponseArray;
    OriginalDesignerLicenses: MemberDashboardLicenseResponseArray;

    private licenseManager: LicenseManager = new LicenseManager();
    private licenseManagerSubscription: Subscription;
    private noteChangeSubscription: Subscription;

    IsBusy: boolean = false;

    product: SelectItem[];
    status: SelectItem[];

    selectedProduct: string;
    selectedStatus: string;

    ownLicenseSearch: string;
    ownLicenseResultRows: number = 25;
    ownLicenseFirstResult: number = 0;
    ownLicenseLastResult: number = 24;

    designerLicenseSearch: string;
    designerLicenseResultRows: number = 25;
    designerLicenseFirstResult: number = 0;
    designerLicenseLastResult: number = 25;

    ToggleCancelledLicenses: boolean = true;
    ToggleCancelledLicensesLabel: string = 'Hide Cancelled';

    constructor(private memberEvents: MemberEventsService,
        private dialogService: DialogService,
        public roles: UserRolesService,
        private windowService: WindowService) {
        this.product = [];
        this.product.push({ label: 'Select Product', value: null });
        this.product.push({ label: 'Vip3D monthly', value: { id: 1, name: 'VIPm' } });
        this.product.push({ label: 'Vip3D yearly', value: { id: 2, name: 'VIPy' } });
        this.product.push({ label: 'VizTerra monthly', value: { id: 3, name: 'VTm' } });
        this.product.push({ label: 'VizTerra yearly', value: { id: 4, name: 'VTy' } });
        this.product.push({ label: 'Pool Studio monthly', value: { id: 5, name: 'PSm' } });
        this.product.push({ label: 'Pool Studio yearly', value: { id: 6, name: 'PSy' } });

        this.status = [];
        this.status.push({ label: 'Select Status', value: null });
        this.status.push({ label: 'Open', value: { id: 1, name: 'open' } });
        this.status.push({ label: 'Canceled', value: { id: 2, name: 'canceled' } });
        this.status.push({ label: 'Terminated', value: { id: 3, name: 'terminated' } });
    }

    ngOnInit() {
        this.licenseManagerSubscription = this.licenseManager.OnIsBusyChanged.subscribe(isBusy => { this.IsBusy = isBusy; });
        this.noteChangeSubscription = this.memberEvents.onNoteChanged.subscribe(args => this.onNoteChanged(args));
    }

    ngOnDestroy() {
        this.licenseManagerSubscription.unsubscribe();
        this.noteChangeSubscription.unsubscribe();
    }

    onNoteChanged(args: EntityChangedArgs<Note>) {

    }

    rowChanged() {

    }

    showMeTheDesigners() {

    }

    onLicenseClick(license: License) {

        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(license.Key, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.refreshClick();
        });

    }

    EditNote(license: License) {

        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.LicenseKey, license.ID);

        if (license.HasNotes) {
            // load

            let noteData = new NoteManagerConstructor(license.ID);
            noteData.NoteType = type;
            noteData.RelationInfo = license.Key;
            noteData.RelationObject = license;

            // let noteManager = new NoteManager(noteData);
			this.ShowNoteDialog(noteData);
			
        } else {
            // add new
            this.AddNote(license);
        }

    }

    AddNote(license: License) {
        // add new
        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.LicenseKey, license.ID);
        let noteData = new NoteManagerConstructor();
        noteData.MemberID = license.MemberID;
        noteData.NoteType = type;
        noteData.RelationInfo = license.Key;
        noteData.RelationObject = license;
        noteData.showTemplates = true;
        noteData.IsAddNote = true;

        // let noteManager = new NoteManager(noteData);
        this.ShowNoteDialog(noteData);

    }

    IsVersionLiveHubCompatible(SoftwareVersion: string){
        //Check for an empty value - that will never be compatible with LiveHub
        if (SoftwareVersion.length === 0 || !SoftwareVersion.trim()){
            return false;
        }

        var cleanSoftwareVersion = SoftwareVersion.replace(/\D/g,'');

        if (cleanSoftwareVersion.length < 4){
            while (cleanSoftwareVersion.length < 4){
                cleanSoftwareVersion = cleanSoftwareVersion + "0";
            }
        }

        var nmcleanSoftwareVersion = Number(cleanSoftwareVersion);

        if (isNaN(nmcleanSoftwareVersion)){
            return false;
        }

        if (nmcleanSoftwareVersion < 2620){
            return false;
        }

        return true;

    }

    ShowNoteDialog(noteData: NoteManagerConstructor) {
        let note = new NoteManager(noteData);
        let options: DialogOptions = {
            width: 1240,
            height: 600
        };
        let disposable = this.dialogService.addDialog(NoteDetailsDialog, { noteManager: note }, options).subscribe(response => {
            disposable.unsubscribe();
        });
    }

    ShowNoteWindow(noteData: NoteManagerConstructor) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<NoteManagerConstructor>(WindowTypes.Note, noteData, windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {
                this.onNoteChanged(event.Data);
            }

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });
    }

    private ReWriteLicense(license: License) {
        // rewrite license values in list
        this.OwnLicenses.forEach((lic) => {
            if (lic.ID == license.ID) {
                // rewrite the gui values
                // --- lic.PackageType = license.PackageType;
                // --- lic.ProductName = LicensePackageTypes[license.PackageType];
                // --- lic.NextBillingDate = license.NextBillingDate;
                lic.Status = license.Status;
                return;
            }
        });

        this.DesignersLicenses.forEach((lic) => {
            if (lic.ID == license.ID) {
                // --- lic.PackageType = license.PackageType;
                // --- lic.ProductName = LicensePackageTypes[license.PackageType];
                // --- lic.NextBillingDate = license.NextBillingDate;
                lic.Status = license.Status;
                return;
            }
        });
    }

    PackageTypeToString(type: LicensePackageTypes): string {
        return LicensePackageTypes[type];
    }

    LicenseStatusTypeToString(type: LicenseStatusTypes): string {
        return LicenseStatusTypes[type];
    }

    BillingCycleTypeToString(type: BillingCycleTypes): string {
        return BillingCycleTypes[type];
    }

    CancelledLicenseCount(licenses: MemberDashboardLicenseResponseArray) {
        if (!licenses) return false;
        return licenses.filter((license) => {
            if (license.Status == LicenseStatusTypes.Cancelled || license.Status == LicenseStatusTypes.CancelledOpen || license.Status == LicenseStatusTypes.Terminated) {
                return true;
            } else {
                return false;
            }
        }).length;
    }

    ActiveLicenseCount(licenses: MemberDashboardLicenseResponseArray) {
        if (!licenses) return false;
        return licenses.filter((license) => {
            if (license.Status == LicenseStatusTypes.Open || license.Status == LicenseStatusTypes.Registered) {
                return true;
            } else {
                return false;
            }
        }).length;
    }

    toggleCancelledLicenses() {
        this.ToggleCancelledLicenses = !this.ToggleCancelledLicenses;

        if (!this.OriginalDesignerLicenses) {
            this.OriginalDesignerLicenses = <MemberDashboardLicenseResponseArray>[...this.DesignersLicenses];
            this.OriginalOwnLicenses = <MemberDashboardLicenseResponseArray>[...this.OwnLicenses];
        }

        if (!this.ToggleCancelledLicenses) {
            this.ToggleCancelledLicensesLabel = 'Show Cancelled';
            this.DesignersLicenses = <MemberDashboardLicenseResponseArray>this.DesignersLicenses.filter((license) => {
                if (license.Status == LicenseStatusTypes.Cancelled || license.Status == LicenseStatusTypes.CancelledOpen || license.Status == LicenseStatusTypes.Terminated) {
                    return false;
                } else {
                    return true;
                }
            });

            this.OwnLicenses = <MemberDashboardLicenseResponseArray>this.OwnLicenses.filter((license) => {
                if (license.Status == LicenseStatusTypes.Cancelled || license.Status == LicenseStatusTypes.CancelledOpen || license.Status == LicenseStatusTypes.Terminated) {
                    return false;
                } else {
                    return true;
                }
            });
        } else {
            this.ToggleCancelledLicensesLabel = 'Hide Cancelled';
            this.OwnLicenses = this.OriginalOwnLicenses;
            this.DesignersLicenses = this.OriginalDesignerLicenses;
        }
    }

    refreshClick() {
        this.refreshEvent.emit('refresh me baby!');
    }

    ShowReactivateLicenseButton(type: LicenseStatusTypes): boolean {

        if (type == LicenseStatusTypes.Open || type == LicenseStatusTypes.Registered)
            return false;
        else
            return true;

    }

    ShowTransferKeyDialog(CDKey) {
        let options: DialogOptions = {
            width: 500,
            height: 300
        };
        let disposable = this.dialogService.addDialog(KeyTransferDialog, {
            CDKey: CDKey
        }, options).subscribe(response => {
            disposable.unsubscribe();
            this.refreshClick();
        }, error => {
            disposable.unsubscribe();
        });
    }

    ShowReactivateKeyDialog(Item: MemberDashboardLicenseResponse) {
        let options: DialogOptions = {
            width: 500,
            height: 750
        };
        let disposable = this.dialogService.addDialog(KeyReactivateDialog, {
            CDKey: Item.Key,
            MemberID: this.MemberID,
            LicenseID: Item.ID,
            License: Item,
            DashboardData: this.DashboardData,
        }, options).subscribe(response => {
            disposable.unsubscribe();
            this.refreshClick();
        }, error => {
            disposable.unsubscribe();
        });
    }


    ShowReassignKeyDialog(Item: MemberDashboardLicenseResponse) {
        let options: DialogOptions = {
            width: 500,
            height: 350
        };
        let disposable = this.dialogService.addDialog(KeyReassignDialog, {
            LicenseID: Item.ID,
            CDKey: Item.Key
        }, options).subscribe(response => {
            disposable.unsubscribe();
            this.refreshClick();
        }, error => {
            disposable.unsubscribe();
        });
    }


    showAddLicense() {
        let showSetupFee: boolean = this.RequireSetupFee();
        let options: DialogOptions = {
            width: 500
        };
        let disposable = this.dialogService.addDialog(AddLicenseDialog, {
			title : '',
			subTitle : '',
			message : '',
			MemberID: this.MemberID,
            requireSetupFee: showSetupFee,
            AvailableCredit: this.DashboardData.Credit
        }, options).subscribe(response => {
            disposable.unsubscribe();
            this.refreshClick();
        }, error => {
            disposable.unsubscribe();
        });
    }

    RequireSetupFee(): boolean {
        let requireSetupFee: boolean = true;

        this.OwnLicenses.forEach(x => {
            if (x.Status == LicenseStatusTypes.Open || x.Status == LicenseStatusTypes.Registered) {
                requireSetupFee = false;
            }
        });

        this.DesignersLicenses.forEach(x => {
            if (x.Status == LicenseStatusTypes.Open || x.Status == LicenseStatusTypes.Registered) {
                requireSetupFee = false;
            }
        });

        return requireSetupFee;
    }

    IsCancelled(item: MemberDashboardLicenseResponse): boolean {
        let isCancelled = false;

        // Check Item to see if status is one of the cancelled statuses
        if (item.Status == LicenseStatusTypes.Cancelled || item.Status == LicenseStatusTypes.CancelledOpen)
            isCancelled = true;

        return isCancelled;
    }

    paginateOwnLicenses(e) {
        // console.log("paginateSearch :", e);
        this.ownLicenseFirstResult = e.page * e.rows;
        this.ownLicenseLastResult = this.ownLicenseFirstResult + e.rows;
    }

    paginateDesignerLicenses(e) {
        // console.log("paginateSearch :", e);
        this.designerLicenseFirstResult = e.page * e.rows;
        this.designerLicenseLastResult = this.designerLicenseFirstResult + e.rows;
    }

    Title() {
        let title = 'Software Licenses';

        if (this.ToggleCancelledLicenses) {
            title += ' (Active: ' + this.ActiveLicenseCount(this.OwnLicenses) + ' / Cancelled: ' + this.CancelledLicenseCount(this.OwnLicenses) + ')';
        } else {
            title += ' (Active: ' + this.ActiveLicenseCount(this.OwnLicenses) + ')';
        }

        return title;
    }


    /* **************************************************************** */
    /* SORTING STUFFS
    /* **************************************************************** */
    sortByProduct() { this.OwnLicenses = SortBot.SortAuto(this.OwnLicenses, 'Product'); }
    sortByDate() { this.OwnLicenses = SortBot.SortAuto(this.OwnLicenses, 'DateTimeCreated'); }
    sortByCycle() { this.OwnLicenses = SortBot.SortAuto(this.OwnLicenses, 'BillingCycle'); }
    sortByNextBillDate() { this.OwnLicenses = SortBot.SortAuto(this.OwnLicenses, 'NextBillDate'); }
    sortByImagingCredits() { this.OwnLicenses = SortBot.SortAuto(this.OwnLicenses, 'ImagingCredits'); }
    sortByKey() { this.OwnLicenses = SortBot.SortAuto(this.OwnLicenses, 'Key'); }
    sortByVersion() { this.OwnLicenses = SortBot.SortAuto(this.OwnLicenses, 'Version'); }
    sortByStatus() { this.OwnLicenses = SortBot.SortAuto(this.OwnLicenses, 'Status'); }

    sortDesignersByName() { this.DesignersLicenses = SortBot.SortAuto(this.DesignersLicenses, 'MemberFirstName'); }
    sortDesignersByProduct() { this.DesignersLicenses = SortBot.SortAuto(this.DesignersLicenses, 'Product'); }
    sortDesignersByCycle() { this.DesignersLicenses = SortBot.SortAuto(this.DesignersLicenses, 'BillingCycle'); }
    sortDesignersByNextBillDate() { this.DesignersLicenses = SortBot.SortAuto(this.DesignersLicenses, 'NextBillDate'); }
    sortDesignersByCDKey() { this.DesignersLicenses = SortBot.SortAuto(this.DesignersLicenses, 'Key'); }
    sortDesignersByVersion() { this.DesignersLicenses = SortBot.SortAuto(this.DesignersLicenses, 'Version'); }
    sortDesignersByStatus() { this.DesignersLicenses = SortBot.SortAuto(this.DesignersLicenses, 'Status'); }
    sortDesignersByImagingCredits() { this.DesignersLicenses = SortBot.SortAuto(this.DesignersLicenses, 'ImagingCredits'); }

}


